module.exports = __webpack_public_path__ + "static/img/url1.1c1a7a76.png";